const trimLeadingSlash = (value: string) => {
  return value.replace(/^\//g, '');
};

export default trimLeadingSlash;
